'use client';

import React, { useEffect } from 'react';
import { CUSTOM_FONT_PREFIX, isCustomFont } from '../../../utils/fonts';

export default function FontLoaderWrapper({ settings, fonts }) {
	useEffect(() => {
		if ((settings.fontFamily && !isCustomFont(settings.fontFamily)) || (settings.headingFontFamily && !isCustomFont(settings.headingFontFamily))) {
			import('webfontloader').then((WebFont) => {
				WebFont.load({
					google: {
						families: [settings.fontFamily, settings.headingFontFamily].filter((i) => i && !isCustomFont(i)),
					},
				});
			});
		}
		fonts.forEach((font) => {
			const fontUrl = `/api/fonts/${font.id}`;
			const fontFace = new FontFace(`${CUSTOM_FONT_PREFIX}${font.name}`, `url(${fontUrl})`);
			fontFace.load().then(() => document.fonts.add(fontFace));
		});
	});

	return null;
}
